/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

// import { CommentaryVideoBanner } from '@components/CommentaryVideoBanner'
import useCurrentQuestion from '@hooks/useCurrentPage'
import useExamInform from '@hooks/useExamInform'
import { useFontSize } from '@hooks/useFontSize'
import useViewResultModeStore from 'store/viewResultMode'

import QuestionArea from './QuestionArea'

type QuestionAreaContainerProps = {
  isDelivery?: boolean
}

const QuestionAreaContainer: React.FC<QuestionAreaContainerProps> = ({ isDelivery }) => {
  const [fontSize] = useFontSize()
  const { currentQuestionGroup, setCurrentQuestionGroupByCurrentGroupId } =
    useExamInform(isDelivery)
  const { questionPerPage, currentQuestionNumber } = useCurrentQuestion()
  const [currentPairOfQuestionIds, setCurrentPairOfQuestionIds] = useState<number[]>([])
  const { viewResultMode } = useViewResultModeStore()

  useEffect(() => {
    const setQuestionGroup = async () => {
      if (!currentQuestionGroup?.id && !isDelivery) await setCurrentQuestionGroupByCurrentGroupId()
    }
    setQuestionGroup()
  }, [currentQuestionGroup.id, setCurrentQuestionGroupByCurrentGroupId])

  useEffect(() => {
    const newArr = Array.from(Array(questionPerPage), (_, i) => i)
    const currentPairOfQuestionIds: number[] = newArr.reduce((ids: number[], _, i) => {
      const question = currentQuestionGroup.questions.find(
        (q: { number: number }) => q.number === +currentQuestionNumber + i
      )
      if (question) ids.push(question.id)
      return ids
    }, [])
    setCurrentPairOfQuestionIds(currentPairOfQuestionIds)
  }, [currentQuestionNumber, questionPerPage, currentQuestionGroup.questions])

  const questionAreaProps = {
    questionIds: currentPairOfQuestionIds,
    fontSize,
    viewResultMode,
    isDelivery,
  }

  return (
    <>
      <QuestionArea {...questionAreaProps} />
    </>
  )
}

export default QuestionAreaContainer
